import { FuseNavigationItem } from '@fleet/model';

export const jobDetailNavigation: FuseNavigationItem[] = [
  {
    title: 'Job Details',
    id: 'job.overview',
    type: 'group',
    children: [
      {
        title: 'Overview',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: './dashboard',
        securityFunctions: ['JOB_DETAIL:read'],
      },
      {
        id: 'job.map',
        title: 'Map',
        type: 'basic',
        icon: 'heroicons_outline:map',
        link: './map',
        securityFunctions: ['JOB_MAP:read'],
      },
      {
        id: 'job.timeline',
        title: 'Timeline',
        type: 'basic',
        icon: 'heroicons_outline:clock',
        link: './timeline',
        securityFunctions: ['JOB_TIMELINE:read'],
      },
      {
        id: 'job.dispatch_logs',
        title: 'Dispatch Logs',
        type: 'basic',
        icon: 'heroicons_outline:server',
        link: './dispatch-logs',
        securityFunctions: ['JOB_DISPATCH_LOGS:read'],
      },
    ],
  },
  {
    title: 'Payment',
    type: 'group',
    securityFunctions: ['JOB_PRICING:read', 'JOB_PAYMENT:read'],
    children: [
      {
        title: 'Pricing',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: './pricing',
        securityFunctions: ['JOB_PRICING:read'],
      },
      //call below module job-payment-sales
      {
        title: 'Payment',
        type: 'basic',
        icon: 'heroicons_outline:credit-card',
        link: './payments',
        securityFunctions: ['JOB_PAYMENT:read'],
      },
    ],
  },
  {
    id: 'job.service',
    title: 'Service',
    type: 'group',
    securityFunctions: [
      'JOB_RATINGS:read',
      'JOB_CALLS:read',
      'JOB_NOTES:read',
      'JOB_TICKETS:read',
    ],
    children: [
      {
        title: 'Ratings',
        type: 'basic',
        icon: 'heroicons_outline:star',
        link: './ratings',
        securityFunctions: ['JOB_RATINGS:read'],
      },

      {
        title: 'Calls',
        type: 'basic',
        icon: 'heroicons_outline:phone',
        link: './communications',
        securityFunctions: ['JOB_CALLS:read'],
      },

      {
        title: 'Notes',
        type: 'basic',
        icon: 'heroicons_outline:pencil-alt',
        link: './notes',
        securityFunctions: ['JOB_NOTES:read'],
      },
      {
        title: 'Service Tickets',
        type: 'basic',
        icon: 'heroicons_outline:support',
        link: './tickets',
        securityFunctions: ['JOB_TICKETS:read'],
      },
    ],
  },
];

export const travellerJobDetailNavigation: FuseNavigationItem[] = [
  {
    title: 'Job Details',
    id: 'job.overview',
    type: 'group',
    children: [
      {
        title: 'Overview',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: './dashboard',
      },
      //leave map
      {
        id: 'job.map',
        title: 'Map',
        type: 'basic',
        icon: 'heroicons_outline:map',
        link: './map',
      },
    ],
  },
  {
    title: 'Payment',
    type: 'group',
    children: [
      {
        title: 'Pricing',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: './pricing',
      },
      //call below module job-payment-sales
      {
        title: 'Payment',
        type: 'basic',
        icon: 'heroicons_outline:credit-card',
        link: './payments',
      },
    ],
  },
];
